import { Button, Modal } from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { archiveVideoCreator, deleteVideoCreator } from 'creators/shareVideo';

import { hasScope } from 'selectors/scopes';

import {
  PERSONAL_ARCHIVE_WRITE,
  TEAM_ARCHIVE_WRITE,
} from '../../../../../shared/constants/scopes';

const VideoRemoveModal = ({
  isOpen,
  onCloseModal,
  videoId,
  videoIsTeamShared,
  videoIsSharedWithUser,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleArchiveClick = async () => {
    setLoading(true);

    try {
      await dispatch(archiveVideoCreator(videoId));
    } catch (e) {
      setLoading(false);
    }
  };

  const handleDeleteClick = async () => {
    setLoading(true);

    try {
      await dispatch(deleteVideoCreator(videoId));
    } catch (e) {
      setLoading(false);
    }
  };

  const scopes = useSelector(state => ({
    hasTeamArchiveWriteScope: hasScope(state, TEAM_ARCHIVE_WRITE),
    hasPersonalArchiveWriteScope: hasScope(state, PERSONAL_ARCHIVE_WRITE),
  }));

  const canArchive = videoIsTeamShared
    ? scopes.hasTeamArchiveWriteScope
    : !videoIsSharedWithUser && scopes.hasPersonalArchiveWriteScope;

  return (
    <Modal
      isOpen={isOpen}
      onCloseClick={onCloseModal}
      onBackgroundClick={onCloseModal}
      title="How would you like to remove this video?"
      mainButton={
        <Button
          isDisabled={loading}
          onClick={handleDeleteClick}
          variant="primary"
        >
          Delete
        </Button>
      }
      alternativeButton={
        canArchive && (
          <Button isDisabled={loading} onClick={handleArchiveClick}>
            Archive
          </Button>
        )
      }
    />
  );
};

export default VideoRemoveModal;
